import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { buildClassNames, buildClassNameModifiers } from '../util/utils';

export default class SelectItem extends Component {
  static propTypes = {
    /** @ignore */
    className: PropTypes.string,
    /** @ignore
     * Convenvience method for setting the reference for this item
     * (used for selection and scrolling)
     */
    itemRef: PropTypes.func,
    /** Indicates whether the item is disabled */
    disabled: PropTypes.bool,
    /** Indicates whether the item is focused */
    focused: PropTypes.bool,
    /** Function executed when this item is selected */
    onSelect: PropTypes.func,
    /** Function executed when this item is removed */
    onRemove: PropTypes.func,
    /** The item available for selection */
    option: PropTypes.shape({
      /** The rendered representation of the option */
      label: PropTypes.string.isRequired,
      /** The value of the option */
      value: PropTypes.any.isRequired,
    }).isRequired,
    /** Indicates that the current item is selected */
    selected: PropTypes.bool,
  };
  static defaultProps = {
    disabled: false,
    selected: false,
  };
  handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      if (!this.props.disabled) {
        if (this.props.selected) {
          this.props.onRemove(e);
          return;
        }
        this.props.onSelect(e);
      }
    }
  }
  render() {
    const {
      className,
      disabled: disabledProp,
      focused,
      itemRef,
      option,
      onSelect,
      onRemove,
      selected,
      ...other
    } = this.props;
    const disabled = (disabledProp || option.disabled);
    const clickHandler = disabled ? onRemove : onSelect;
    const classNames = buildClassNames(
      buildClassNameModifiers(className, { disabled }, { focused }),
      className,
    );
    let ariaSelected;
    if (selected) {
      ariaSelected = true;
    } else {
      ariaSelected = disabled ? undefined : false;
    }

    return (
      <div
        role='option'
        tabIndex={-1}
        aria-selected={ariaSelected}
        ref={itemRef ? n => itemRef(n, focused) : undefined}
        className={classNames}
        value={option.value}
        onClick={clickHandler}
        onKeyDown={this.handleKeyDown}
        {...other}
      >
        {option.label}
      </div>
    );
  }
}
